<template>
  <transition name="modal">
    <div class="modal-mask confirm">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h1>{{title}}</h1>
            <div class="btn btn-primary" @click="$emit('close')"><i class="fa fa-times" aria-hidden="true"></i></div>
          </div>
          <div class="modal-body">
            <slot name="body">
              {{body}}
              <br/>
              <span v-if="!onlyClose" class="blue-text">{{data.firstname}} {{data.lastname}}</span>
              <span v-if="!onlyClose">?</span>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button grey-button btn btn-default" @click="$emit('close')">Annuler
              </button>
              <button v-if="!onlyClose" class="modal-default-button green-button btn btn-primary" @click="$emit('confirm')">Valider
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: [
      'title',
      'body',
      'data',
      'onlyClose',
    ],
  }
</script>

<style lang="scss">
  @import "../../scss/variables";

  .modal-mask.confirm {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($suez-blue, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-wrapper {
      background-color: white;
      min-width: 475px;
      max-height: 90vh;
      color: $suez-blue;
      border-radius: 6px;
      .modal-header {
        background-color: white;
        position: relative;
        border-bottom: none;
        border-radius: 5px;
        h1 {
          margin: 0;
          font-size: 2.5rem;
          text-align: center;
        }
        div.btn {
          position: absolute;
          top: 0;
          right: 0;
          border-radius: 0 5px 0 0;
          background-color: $suez-green;
          border: solid 1px $suez-green;
          color: $suez-green-dark;
        }
      }
      .modal-body {
        text-align: center;
        .blue-text {
          color: $suez-blue;
          font-weight: bold;
        }
      }
      .modal-footer {
        border: none;
        text-align: center;
        .btn {
          width: 30%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ModalConfirm.vue?cde07d72